var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span',{class:_vm.titleClasses,attrs:{"data-tooltip":_vm.tooltip}},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),(_vm.subheading)?_c('span',{staticClass:"subheading"},[_vm._v(_vm._s(_vm.subheading))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }